
import React from 'react';

interface WillCardSkeletonProps {
  viewMode?: 'grid' | 'list';
}

const WillCardSkeleton: React.FC<WillCardSkeletonProps> = ({ viewMode = 'grid' }) => (
  <div className={`animate-pulse ${viewMode === 'list' ? 'flex gap-4 w-full' : ''} p-4 border border-gray-200 rounded-lg shadow-sm`}>
    <div className={viewMode === 'grid' ? 'space-y-4 w-full' : 'flex-grow space-y-4'}>
      <div className="flex flex-wrap gap-2">
        <div className="h-5 w-16 bg-gray-200 rounded-full"></div>
        <div className="h-5 w-24 bg-gray-200 rounded-full"></div>
      </div>
      <div className="h-6 bg-gray-200 rounded w-3/4"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
      </div>
    </div>
    {viewMode === 'list' && (
      <div className="w-[120px] md:w-[150px] flex flex-col justify-between">
        <div className="h-6 w-20 bg-gray-200 rounded"></div>
        <div className="h-4 w-24 bg-gray-200 rounded"></div>
      </div>
    )}
  </div>
);

export default WillCardSkeleton;
